import { FC } from "react";
import { Box } from "@otrium/core";
import { filter, find } from "lodash-es";
import { Checkbox } from "src/atoms/Checkbox";
import { MultiselectHitType } from "src/types/Algolia";

interface Props {
  items: MultiselectHitType[];
  refine: (value: MultiselectHitType) => void;
  isSelected: (hit: MultiselectHitType) => boolean;
}

export const CategoriesCheckboxTree: FC<Props> = ({
  items,
  refine,
  isSelected,
}) => {
  if (!items.length) {
    return null;
  }

  return (
    <Box pt={2}>
      <Box as="ul" ml={3}>
        {items.map((c) => {
          const name = c.label?.split("||")[1];
          const checked = isSelected(c);
          const children = checked
            ? c.items
            : filter(c.items, (item) => {
                return (
                  isSelected(item) ||
                  !!find(item.items, (child) => isSelected(child))
                );
              });
          return (
            <Box as="li" key={c.label} pb={2}>
              <Checkbox checked={checked} onChange={() => refine(c)}>
                {name}
              </Checkbox>
              {children && (
                <CategoriesCheckboxTree
                  refine={refine}
                  items={children}
                  isSelected={isSelected}
                />
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
